var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: {
        id: "fb-share-modal",
        title: "Share...",
        size: "lg",
        "hide-footer": !_vm.shouldShowModalFooter,
      },
      on: { hide: _vm.onclose, show: _vm.onShow },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass:
                    "mt-2 d-flex justify-content-end align-items-center",
                },
                [
                  _c(
                    "ButtonOutline",
                    {
                      staticClass: "mr-3",
                      on: {
                        click: function ($event) {
                          return _vm.$refs.modal.hide()
                        },
                      },
                    },
                    [_vm._v("\n        Close\n      ")]
                  ),
                  _vm._v(" "),
                  _c("ButtonPrimary", { on: { click: _vm.sendShareEmail } }, [
                    _vm._v("\n        Share\n      "),
                  ]),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass:
                "justify-content-center align-items-center loading custom-styles",
            },
            [
              _c(
                "div",
                {
                  staticClass: "spinner-border text-primary",
                  attrs: { role: "status" },
                },
                [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-form-group",
        { attrs: { label: "Mode" } },
        [
          _c("b-form-radio-group", {
            attrs: { options: _vm.options },
            on: { change: _vm.fetchShareLink },
            model: {
              value: _vm.mode,
              callback: function ($$v) {
                _vm.mode = $$v
              },
              expression: "mode",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _c(
            "b-form-checkbox",
            {
              attrs: { value: true, "unchecked-value": false },
              on: { change: _vm.clickLoginRequired },
              model: {
                value: _vm.isLoginRequired,
                callback: function ($$v) {
                  _vm.isLoginRequired = $$v
                },
                expression: "isLoginRequired",
              },
            },
            [_vm._v("\n      Login required\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOneSelected,
              expression: "isOneSelected",
            },
          ],
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-items-center" },
            [
              _c(
                "b-form-checkbox",
                {
                  attrs: { value: true, "unchecked-value": false },
                  on: { change: _vm.clickDirectLinkToFile },
                  model: {
                    value: _vm.isDirectLinkToFile,
                    callback: function ($$v) {
                      _vm.isDirectLinkToFile = $$v
                    },
                    expression: "isDirectLinkToFile",
                  },
                },
                [_vm._v("\n        Direct link to file\n      ")]
              ),
              _vm._v(" "),
              _vm.showLiveViewerButton
                ? _c(
                    "b-form-checkbox",
                    {
                      staticClass: "ml-3",
                      attrs: { value: true, "unchecked-value": false },
                      on: { change: _vm.applyLiveViewerPrefix },
                      model: {
                        value: _vm.isLiveViewer,
                        callback: function ($$v) {
                          _vm.isLiveViewer = $$v
                        },
                        expression: "isLiveViewer",
                      },
                    },
                    [_vm._v("\n        Live Viewer\n      ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _vm.isDirectLinkToFile && _vm.isDirectFileSelection
            ? _c(
                "b-form-radio-group",
                {
                  staticClass: "mt-2 ml-4",
                  attrs: { stacked: "" },
                  on: { change: _vm.clickDirectLinkType },
                  model: {
                    value: _vm.directLinkType,
                    callback: function ($$v) {
                      _vm.directLinkType = $$v
                    },
                    expression: "directLinkType",
                  },
                },
                [
                  _c("b-form-radio", { attrs: { value: "path" } }, [
                    _vm._v("\n        Use file path\n      "),
                  ]),
                  _vm._v(" "),
                  _c("b-form-radio", { attrs: { value: "original" } }, [
                    _vm._v("\n        Use original name\n      "),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _c(
            "b-form-checkbox",
            {
              attrs: { value: true, "unchecked-value": false },
              model: {
                value: _vm.isShareToEmail,
                callback: function ($$v) {
                  _vm.isShareToEmail = $$v
                },
                expression: "isShareToEmail",
              },
            },
            [_vm._v("\n      Send share to email\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isShareToEmail,
              expression: "isShareToEmail",
            },
          ],
        },
        [
          _c(
            "b-form-group",
            [
              _c("label", { attrs: { for: "email-to-share" } }, [
                _vm._v("Please enter emails to share with:"),
              ]),
              _vm._v(" "),
              _c("b-form-tags", {
                attrs: { id: "email-to-share", placeholder: "Email addresses" },
                model: {
                  value: _vm.emailToShare,
                  callback: function ($$v) {
                    _vm.emailToShare = $$v
                  },
                  expression: "emailToShare",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            [
              _c("label", { attrs: { for: "subject" } }, [_vm._v("Subject")]),
              _vm._v(" "),
              _c("b-form-input", {
                attrs: { id: "subject" },
                model: {
                  value: _vm.subject,
                  callback: function ($$v) {
                    _vm.subject = $$v
                  },
                  expression: "subject",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            [
              _c("label", { attrs: { for: "body" } }, [_vm._v("Body")]),
              _vm._v(" "),
              _c("b-form-textarea", {
                attrs: { id: "body", rows: "4" },
                model: {
                  value: _vm.body,
                  callback: function ($$v) {
                    _vm.body = $$v
                  },
                  expression: "body",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _c(
            "b-form-checkbox",
            {
              attrs: { value: true, "unchecked-value": false },
              model: {
                value: _vm.isNotifyMe,
                callback: function ($$v) {
                  _vm.isNotifyMe = $$v
                },
                expression: "isNotifyMe",
              },
            },
            [_vm._v("\n      Notify me of activity\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _c(
            "b-form-checkbox",
            {
              attrs: { value: true, "unchecked-value": false },
              model: {
                value: _vm.isNotifyOthers,
                callback: function ($$v) {
                  _vm.isNotifyOthers = $$v
                },
                expression: "isNotifyOthers",
              },
            },
            [_vm._v("\n      Notify others...\n    ")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _vm.isNotifyOthers
            ? _c("b-form-tags", {
                attrs: { placeholder: "Email addresses" },
                model: {
                  value: _vm.notifyOtherEmail,
                  callback: function ($$v) {
                    _vm.notifyOtherEmail = $$v
                  },
                  expression: "notifyOtherEmail",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _c("label", [_vm._v("Share a link")]),
          _vm._v(" "),
          _c(
            "b-input-group",
            [
              _c("b-form-input", {
                ref: "share",
                model: {
                  value: _vm.shareLink,
                  callback: function ($$v) {
                    _vm.shareLink = $$v
                  },
                  expression: "shareLink",
                },
              }),
              _vm._v(" "),
              _c(
                "b-input-group-append",
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        id: "copy-to-clipboard",
                        size: "sm",
                        title: "Click to copy",
                        variant: "secondary",
                      },
                      on: { click: _vm.copyToClipboard },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-clipboard",
                        attrs: { "aria-hidden": "true" },
                      }),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tooltip",
                    {
                      ref: "tooltip",
                      attrs: { target: "copy-to-clipboard", triggers: "none" },
                    },
                    [_vm._v("\n          Copied\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }